.container {
  position: relative;
  background: var(--color-grayscale-trout);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: start;
  border-radius: 0.4rem;
  order: 1;
  padding: 0 1.6rem;
  gap: 0.2rem;
  min-width: 0;

  @media screen and (min-width: $bp-medium) {
    padding: 0;
    border-radius: 0;
    background: var(--color-grayscale-tuna);
    gap: unset;
    order: unset;
  }
}

.time-container {
  width: 100%;
  border-radius: 0;

  @media screen and (min-width: $bp-medium) {
    background: var(--color-grayscale-shark);
    border-radius: 0 0 0.4rem 0.4rem;
    padding: 0 1.6rem 1.6rem 1.6rem;
  }
}

.content {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--color-grayscale-trout);
  border-radius: 0.4rem;

  /* Hook class handed to InlineTimeSelector, which forwards it to the
     TimeDisplay it renders. Was `& > ${TimeDisplay}`, a reference to a
     component owned by another module. */
  & > .time-display {
    color: var(--color-grayscale-white);
    margin: 0;
    font-size: 4rem;
    font-weight: 700;
    padding: 0 1.6rem;

    @media screen and (max-width: #{$bp-medium + 1}) {
      & > span {
        font-weight: 500;
        font-size: 2.4rem;
      }
    }

    @media screen and (min-width: $bp-medium) {
      width: 100%;
      padding: 2.4rem;
      font-size: 6rem;
    }
  }
}

.footer {
  all: unset;
  font-weight: 500;
  font-size: 1.4rem;
  text-align: center;
  padding: 0.4rem 0.8rem;
  margin: auto;
  color: var(--color-grayscale-white);
  width: fit-content;
  cursor: pointer;

  &:hover,
  &:focus-visible {
    background-color: var(--color-grayscale-arsenic);
    border-radius: 0.4rem;
  }

  @media screen and (min-width: $bp-medium) {
    font-size: 2rem;
    line-height: 2.4rem;
  }
}

.mobile-button-wrapper {
  position: absolute;
  top: 0.8rem;
  right: 1.6rem;

  @media screen and (min-width: $bp-medium) {
    display: none;
  }
}
